"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuOption = exports.Menu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./Menu.css");
var classnames_1 = __importDefault(require("classnames"));
var css_1 = require("@emotion/css");
var Popover_1 = require("../../components/Popover");
var Menu = function (_a) {
  var className = _a.className,
    _b = _a.width,
    width = _b === void 0 ? "128px" : _b,
    minWidth = _a.minWidth,
    maxWidth = _a.maxWidth,
    refObject = _a.refObject,
    restProps = __rest(_a, ["className", "width", "minWidth", "maxWidth", "refObject"]);
  var cn = (0, css_1.css)({
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth
  });
  return (0, jsx_runtime_1.jsx)("div", __assign({
    ref: refObject,
    className: (0, classnames_1.default)("vsx-menu", className, cn)
  }, restProps));
};
exports.Menu = Menu;
var MenuOption = function (_a) {
  var _b;
  var className = _a.className,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c,
    _d = _a.selected,
    selected = _d === void 0 ? false : _d,
    tooltip = _a.tooltip,
    tooltipProps = _a.tooltipProps,
    hoverTextColor = _a.hoverTextColor,
    restProps = __rest(_a, ["className", "disabled", "selected", "tooltip", "tooltipProps", "hoverTextColor"]);
  var colorClass = (0, css_1.css)({
    "--hoverColor": hoverTextColor
  });
  return (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    placement: "top",
    distance: 5,
    interactive: false,
    disabled: !tooltip,
    content: tooltip,
    tooltip: true
  }, tooltipProps, {
    wrapperProps: __assign(__assign({}, tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.wrapperProps), {
      className: (0, classnames_1.default)("vsx-menu-option-wrapper", (_b = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.wrapperProps) === null || _b === void 0 ? void 0 : _b.className)
    })
  }, {
    children: (0, jsx_runtime_1.jsx)("button", __assign({
      "data-selected": selected,
      disabled: disabled,
      className: (0, classnames_1.default)("vsx-menu-option", colorClass, className)
    }, restProps))
  }));
};
exports.MenuOption = MenuOption;